export default __webpack_public_path__ + "static/media/type_10_5.f70faf7f.svg";